export default {
  title: {
    register: 'ลงทะเบียนเข้าสู่ระบบครั้งแรก',
    login: 'เข้าสู่ระบบ',
    logout: 'ออกจากระบบ'
  },
  label: {
    plzSetting: 'กรุณาตั้งค่าอีเมลและรหัสผ่านสำหรับบัญชีของคุณ',
    setNewPassword: 'กรุณาตั้งรหัสผ่านใหม่สำหรับบัญชีของคุณ',
    editPassword: 'แก้ไขรหัสผ่าน',
    newPassword: 'ตั้งค่ารหัสผ่านใหม่',
    passwordNew: 'รหัสผ่านใหม่',
    oldPassword: 'รหัสผ่านเดิม',
    inputOldPassword: 'กรอกรหัสผ่านเดิม',
    inputNewPassword: 'กรอกรหัสผ่านใหม่',
    newPasswordConfirmation: 'กรอกยืนยันรหัสผ่านใหม่',
    myAccount: 'บัญชีของฉัน',
    password: 'รหัสผ่าน',
    confirmPass: 'ยืนยันรหัสผ่าน',
    confirmNewPassword: 'ยืนยันรหัสผ่านใหม่',
    passwordChangeSuccess: 'เปลี่ยนรหัสผ่านสำเร็จ',
    confirm: 'ยืนยัน',
    welcome: 'ยินดีต้อนรับ!',
    forgetPass: 'ลืมรหัสผ่าน?',
    passwordResetEmailMessage: 'คุณจะได้รับอีเมลพร้อมคำแนะนำวิธีการรีเซ็ตรหัสผ่านของคุณ',
    sendEmail: 'ส่งอีเมล',
    signName: 'ลงชื่อ',
    emailSuccessMessage: 'ส่งอีเมลเรียบร้อยแล้ว',
    checkEmailNotice: 'เราได้ส่งข้อมูลไปยังอีเมลของคุณแล้ว กรุณาตรวจสอบอีเมลของคุณ',
    emailRetryNotice: 'อาจใช้เวลาประมาณ 2-3 นาที หากไม่ได้รับอีเมล กรุณาลองอีกครั้ง'

  },
  placeholder: {
    confirmPass: 'กรอกยืนยันรหัสผ่าน',
    password: 'กรอกรหัสผ่าน',
    keepPassword: 'จำรหัสผ่านของคุณ',
    plzEnterEmail: 'โปรดกรอกอีเมล',
    plzEnterClinicDetail: 'กรุณากรอกรายละเอียดเพื่อสร้างคลินิกใหม่'
  },
  toolTip: {
    ok: 'โอเค ฉันเข้าใจแล้ว'
  },
  modal: {
    create: {
      user: {
        success: 'สร้าง user สำเร็จ !'
      },
      clinic: {
        title: 'สร้างคลินิก',
        newClinic: 'สร้างคลินิกใหม่',
        success: 'สร้างคลินิกใหม่สำเร็จ',
        success2: 'การสร้างคลินิกใหม่เสร็จสมบูรณ์แล้ว'
      }
    }
  }
}
